const translations = {
    addNewCustomer: 'Add a new customer',
    company: 'Company',
    contact: 'Person Of Contact',
    phoneNumber: 'Phone Number'
};

export default translations;
